function ListGroupType1({ label = "Fill Label", value = "Fill Value Here", onClick = () => {} }) {
  return (
    <>
      <div className="list-group list-group-flush">
        <div className="list-group-item d-flex align-items-center">
          <div className="flex-1 text-break">
            <div className="text-theme">{label}</div>
            <div className="text-inverse text-opacity-50">{value}</div>
          </div>
          <div className="w-50px text-center">
            <a href="#/" onClick={onClick} className="btn btn-outline-default btn-sm">
              <i className="fas fa-edit text-theme"></i>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default ListGroupType1;
